import React__default from 'react';
import PropTypes__default from 'prop-types';
import StreamlineIcon from './StreamlineIcon.js';
import SvgKeyboardArrowRight from '../../common/streamlinehq/img/streamline-regular/interface-essential/keyboard/keyboard-arrow-right.svg.js';

var ArrowRightIcon = function ArrowRightIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React__default.createElement(StreamlineIcon, {
    className: className
  }, /*#__PURE__*/React__default.createElement(SvgKeyboardArrowRight, null));
};
ArrowRightIcon.defaultProps = {};
ArrowRightIcon.propTypes = {
  className: PropTypes__default.string
};

export { ArrowRightIcon as default };
//# sourceMappingURL=ArrowRightIcon.js.map
